import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import "./index.css";
import axios from 'axios';
import OptSearch_SingleInputText from "../OptSearch_SingleInputText/OptSearch";

class View_type_26 extends Component {
    constructor(props) {
        super(props);

        var data = { ...props.data };

        this.state = {
            data: data,
            // isVisible:true,
            counter: data.items_per_page ? data.items_per_page : null,
            counterX: 1,
            artists: data.artists ? data.artists : null
        };
        //console.log("View_type_26: ", this.state);
    }


    updateHandler = () => {
        this.updateList();
    }

    updateList = () => {
        let offset = this.state.data.items_per_page;
        let counter = this.state.counterX;

        this.setState(() => {
            return {
                counterX: counter += 1
            };
        });


        let link = `${this.state.data.button_lazy_load.url}${this.state.counter}?lang=${this.state.data.button_lazy_load.lang}&offset=${offset * this.state.counterX}`;

        axios
            .get(link)
            .then(res => {
                const data = res.data.artists;
                if (data.length) {
                    this.setState({
                        data: {
                            ...this.state.data,
                            artists: this.state.data.artists.concat(data)
                        }
                    })
                }
            })
            .catch((error) => {
                this.setState({
                    isVisible: false
                })
            })
    };


    render() {
        const searchArea = this.state.data.optional_search_area ? (<OptSearch_SingleInputText />) : (null);

        return (
            <div>
                <div className="vt26 left left--tablet col-xs-12 col-sm-12 col-md-9 col-lg-9">

                    {/* OPTIONAL SEARCH ENGINE BASED ON STATE VALUE */}
                    {searchArea}

                    {/* LIST OF ARTISTS / PEOPLE */}
                    {this.state.data.artists ?
                        (
                            <div id="list-container" className={this.state.data.institutions ? "institutions" : ""}>
                                {this.state.data.artists.map(artist => (
                                    <div>
                                        {artist.url.length > 0 ? (
                                            <Link to={artist.url}>
                                                {artist.name}
                                            </Link>
                                        ) : (
                                            artist.name
                                        )}
                                    </div>
                                )
                                )}
                            </div>
                        )
                        : null}

                    {/* LOAD BUTTON */}
                    {this.state.data.button_lazy_load ?
                        (
                            <button style={{ background: window.globalColor }} className="button-load-news" onClick={this.updateHandler}>
                                {this.state.data.button_lazy_load ?
                                    (this.state.data.button_lazy_load.text)
                                    :
                                    ("Pokaż kolejne rekordy")}
                            </button>
                        )
                        : null
                    }
                </div>
                <div className="vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3">
                    {/* LIST OF LETTERS */}
                    {this.state.data.letters ?
                        (
                            <div id="letter-container">
                                {this.state.data.letters.map(item => (
                                    <Link to={item.url}>
                                        <div className="letter-item">
                                            {item.letter}
                                        </div>
                                    </Link>
                                )
                                )}
                            </div>
                        )
                        : null
                    }
                </div>

            </div>
        )
    }
}
export default withRouter(View_type_26)



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_26/index.js